import { numberHelper } from './numberHelper';

export const formatZipCode: (zip: string) => string = (zip) => {
  const assignZipCode = zip.substring(0, 10);
  const [zipCode, suffix] = [assignZipCode.substring(0, 5), assignZipCode.substring(5, 9)];
  let outZipCode = zipCode;
  // Only add punctuation when there is something for the punctuation to be between.
  if (zipCode.length === 5 && suffix.length > 0) {
    outZipCode = outZipCode + ' - ';
  }
  outZipCode = outZipCode + (suffix || '');
  return outZipCode;
};

export const formatPhone: (phone: string) => string = (phone) => {
  const assignMobile = phone.replace(/\D/g, '').substring(0, 10);
  const [areaCode, prefix, suffix] = [
    assignMobile.substring(0, 3),
    assignMobile.substring(3, 6),
    assignMobile.substring(6, 10),
  ];
  let outMobile = '';
  // Only add punctuation when there is something for the punctuation to be between.
  if (areaCode.length > 0) {
    outMobile = '(' + areaCode;
  }
  if (areaCode.length === 3 && prefix.length > 0) {
    outMobile = outMobile + ') ';
  }
  outMobile = outMobile + (prefix ?? '');
  if (prefix.length === 3 && suffix.length > 0) {
    outMobile = outMobile + '-';
  }
  outMobile = outMobile + (suffix ?? '');
  return outMobile;
};

export const mapMobileNumberFieldInsertPositionToNewCursorPosition: Record<number, number> = {
  0: 2,
  3: 7,
  5: 7,
  9: 11,
};

export const calculateNewCursorPosition = (
  inputType: MobileNumberInputType,
  previousCursorPosition: number,
  changeEventCursorPosition: number
): number => {
  if (inputType === 'insertText') {
    return mapMobileNumberFieldInsertPositionToNewCursorPosition[previousCursorPosition] ?? changeEventCursorPosition;
  }

  return changeEventCursorPosition;
};

export type TextInputChangeEvent = React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>;

export type MobileNumberInputType = 'deleteContentBackward' | 'deleteContentForward' | 'insertText';

export const getFormattedDiscountedPrice = (discountedPrice: number) => {
  const formattedPrice = numberHelper.formatMoney(Math.abs(discountedPrice));
  if (discountedPrice === 0) {
    return 'Free';
  } else if (discountedPrice < 0) {
    return `-${formattedPrice}`;
  } else {
    return formattedPrice;
  }
};
